import { useEffect, useRef, useState } from "react"
import { useOutletContext } from "react-router"
import { ScrollWrapper } from "@/components/scroll-wrapper"
import { ChatMessageItem } from "@/modules/chats/components/chat-message/chat-message"
import { ChatSystemMessage } from "@/modules/chats/components/chat-message/chat-system-message"
import { groupMessage } from "@/modules/chats/lib/message-helper"
import { ChatMessageGroup, SofiaChatMessage } from "@/modules/chats/types/chat-message"
import { ChatPatient } from "@/modules/chats/types/chat-thread"
import { PatientFragment$data } from "@/modules/patients/services/__generated__/PatientFragment.graphql"

type ChatTranscriptContentProps = {
  chatTranscriptMessagesContent: SofiaChatMessage[]
  patientId: string
  appointmentId: string
}

const convertToChatPatient = (patientData: PatientFragment$data): ChatPatient => {
  return {
    id: patientData.id,
    address: patientData.address,
    birthDate: patientData.birthDate,
    emailAddress: patientData.emailAddress,
    firstName: patientData.firstName,
    lastName: patientData.lastName,
    country: patientData.country,
    gender: patientData.gender,
    phoneNumber: patientData.phoneNumber,
    age: {
      years: patientData.age.years,
      isMajor: patientData.age.years >= 18,
    },
  }
}

const ChatTranscriptContent = (props: ChatTranscriptContentProps) => {
  const { chatTranscriptMessagesContent, appointmentId } = props
  const { patient } = useOutletContext<{ patient: PatientFragment$data }>()
  const [messageGroup, setMessageGroup] = useState<ChatMessageGroup[]>([])
  const listContainerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    setMessageGroup(groupMessage(chatTranscriptMessagesContent))
  }, [chatTranscriptMessagesContent])

  return (
    <ScrollWrapper ref={listContainerRef} className="h-full px-4 pb-6">
      <div className="mt-auto grid gap-4">
        {[...messageGroup].map((group) => {
          return (
            <div key={group.id} className="grid gap-0.5">
              {group.messages?.map((message, messageIndex) => {
                if (message.role === "system") {
                  return <ChatSystemMessage key={message.id} message={message} />
                }

                return (
                  <ChatMessageItem
                    key={message.id}
                    chatMessage={message}
                    isLastMessageInGroup={messageIndex === group.messages.length - 1}
                    shouldShowAvatar={false}
                    appointmentId={appointmentId}
                    patient={convertToChatPatient(patient)}
                    patientLanguage={patient.primaryLanguage}
                    liveTranslation={{ isLiveTranslationEnabled: false, selectedTargetLanguage: null }}
                  />
                )
              })}
            </div>
          )
        })}
      </div>
      <div id="last-item"></div>
    </ScrollWrapper>
  )
}

export default ChatTranscriptContent
